import classes from "./styles/style.module.css";
import AwardsImg from "../../../assets/images/joftPooch/awardsIcon.svg";
import RulesImg from "../../../assets/images/joftPooch/rulesImg.png";
import HintImg from "../../../assets/images/joftPooch/HintImg.png";

export const rulesDialog = (
  <div className="w-100">
    <img src={RulesImg} alt="awardIcon" className={classes.alertBanner} />
    <p className={classes.title}>قوانین</p>
    <div className={classes.dialogContent}>
      <p className="text-right">
        سلام
        <br />
        <br />
        قوانین چالش جفت پوچ:
        <br />
        هر نفر فقط و فقط یک بار میتونه در چالش هفتگی شرکت کنه.
        <br />
        وقتی چالش رو شروع کردی، دیگه باید تا تهش بری؛ چون مثل زندگی دکمه برگشت
        نداره! 😊
        <br />
        <br />
        چالش هفتگی در ساعت 18:00 هر پنجشنبه فعال میشه و تا ساعت 18:00 روز جمعه
        فعال میمونه.
        <br />
        <br />
        چالش جفت پوچ یه بازی خاصه. برای همین ادبیاتش هم خاصه. مثلا به جای سکه
        میگیم پله و به جای لِوِل هم میگیم طبقه و یه چیز دیگه‌ای داریم به نام
        کلید. اینا همه‌ش توضیح و تفسیر داره که خودت داری میفهمی 😉 هر سؤال که
        جواب میدی، 10 پله میگیری و طبق فرمول هر چند پله یک طبقه میری بالا
      </p>
    </div>
  </div>
);

export const tutorialDialog = (
  <div className="w-100 text-center">
    <img src={HintImg} alt="awardIcon" className={classes.alertBanner} />
    <p className={classes.title}>راهنمای چالش</p>
    <div className={classes.dialogContent}>
      <p>
        اگر کنار هر ایموجی بلندگو 🔊 بود به معنای صدای ان ایموجی است
        <br />
        <br />
        اگر علامت مساوی = کنار ایموجی امد به معنای معادل ان است
        <br />
        <br />
        اگر cun امد به معنای اسم ان کشور است
        <br />
        <br />
        اگر en یا عربی امد یعنی معادل فارسی ان در زبان انگلیسی
        <br />
        <br />
        اگر علامت دو فلش برعکس‌ 🔁 بود یعنی حروفش را برعکس کن
        <br />
        <br />
        💸کنار نماد یک کشور نشان دهنده ی واحد پول
        <br />
        <br />
        ❌مخالف کلمه
      </p>
    </div>
  </div>
);

export const awardsDialog = (
  <div className="w-100">
    <img src={AwardsImg} alt="awardIcon" className={classes.alertBanner} />
    <p className={classes.title}>جوایز</p>
    <div className={classes.dialogContent}>
      <p className="font-weight-bold">جوایز ماهانه</p>
      <div className="d-flex ">
        <p className="mb-2">⌚ ساعت هوشمند</p>
      </div>
      <div className="d-flex ">
        <p className="mb-2">🎧 هندزفری</p>
      </div>
      <div className="d-flex ">
        <p className="mb-2">👕 گرمکن ورزشی</p>
      </div>
      <div className="d-flex ">
        <p className="mb-2">🎲 بازی رومیزی</p>
      </div>
      <div className="d-flex ">
        <p className="mb-2">🥛 ماگ جفت پوچ</p>
      </div>
      <div className="w-100 my-3">
        <p className="font-weight-bold">جوایز نهایی</p>
        <div className="d-flex ">
          <p className="mb-2">🚲 دوچرخه</p>
        </div>
        <div className="d-flex ">
          <p className="mb-2">💻 لب‌ تاب</p>
        </div>
        <div className="d-flex ">
          <p className="mb-2">📱 تلفن همراه</p>
        </div>
        <div className="d-flex ">
          <p className="mb-2">🔭 تلسکوپ</p>
        </div>
      </div>
    </div>
  </div>
);
